// This file added by Bearer Web Developer
import { Tooltip } from "@mui/material";
import React from "react";
import styles from './cancelTooltip.module.scss';
interface Props {
    text: string
}
const CancelTooltip: React.FC<Props> = ({ text }) => {

    const [open, setOpen] = React.useState(false);
    return (
        <Tooltip title={text} arrow={true}
            classes={{ tooltip: styles.tooltip, arrow: styles.arrow }}
            open={open}
       
            onClose={() => {
                console.log("close tooltip");
                setOpen(false);
            }}>
            <div className={styles.help}
                onClick={() => {
                    setOpen(prev => !prev);
                    console.log("click tooltip");
                }}>
                <img src="/help-red.svg" alt="why" width={18} height={18} />
            </div>
        </Tooltip>
    )
}
export default CancelTooltip;
